import React from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { AUIModal } from '@ancert/aui-modal';
import valide from '../../../../assets/images/valide.png';
import firma from '../../../../assets/images/firma.png';
import './ModalAyuda.scss';
import ValidationContent from '../ModalValidacionFirma/ValidationContent';

/**
 * Modal para mostrar información de ayuda
 * @param {Object} props - Props del componente
 * @param {boolean} props.show - Controla si el modal está visible
 * @param {function} props.onClose - Función para cerrar el modal
 * @returns {React.ReactElement} - Componente ModalAyuda
 */
const ModalAyuda = ({ show, onClose }) => {
  const { t } = useTranslation();

  return (
    <AUIModal
      autoHeight
      size="xl"
      show={show}
      title={t('modalAyuda.title')}
      actionButtons={[
        {
          id: 'tertiary',
          mode: 'tertiary',
          label: t('backButton'),
          onClick: onClose,
          disabled: false,
        },
      ]}
      onClose={onClose}
    >
      <div className="modal-content modal-ayuda-content">
        {/* Sección 1 */}
        <section className="modal-ayuda-section">
          <h3 className="modal-ayuda-title">{t('modalAyuda.section1')}</h3>
          <p className="modal-ayuda-description">
            <Trans
              i18nKey="modalAyuda.desc1"
              components={{
                strong: <strong />,
              }}
            />
          </p>
          <div className="modal-ayuda-image">
            <ValidationContent />
          </div>
        </section>

        {/* Sección 2 */}
        <section className="modal-ayuda-section">
          <h3 className="modal-ayuda-title">{t('modalAyuda.section2')}</h3>
          <p className="modal-ayuda-description">
            <Trans
              i18nKey="modalAyuda.desc2"
              components={{
                strong: <strong />,
              }}
            />
          </p>
          <div className="modal-ayuda-image">
            <img src={firma} alt="Validar firma mediante Sede Electrónica" />
          </div>
        </section>

        {/* Sección 3 */}
        <section className="modal-ayuda-section">
          <h3 className="modal-ayuda-title">{t('modalAyuda.section3')}</h3>
          <p className="modal-ayuda-description">
            <Trans
              i18nKey="modalAyuda.desc3"
              components={{
                strong: <strong />,
              }}
            />{' '}
            <a href="https://valide.redsara.es/" target="_blank" rel="noopener noreferrer" className="modal-ayuda-link">
              {t('modalAyuda.linkText')}
            </a>
            .
          </p>
          <div className="modal-ayuda-image">
            <img src={valide} alt="Validar firma con VALIDe" />
          </div>
        </section>
      </div>
    </AUIModal>
  );
};

ModalAyuda.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalAyuda;
